/**
 * Must be the first import of every entry point (main.tsx, the DB worker). Zod 4
 * probes `new Function("")` when an object schema is constructed, to decide whether
 * to JIT its parsers. The throw is caught, but under our CSP (Trusted Types) the
 * probe is still reported as a violation. jitless skips the probe.
 */
import { config } from "zod";

config({ jitless: true });
